export function formatDate(dateString, separator = "/") {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}${separator}${month}${separator}${year}`;
}

export function formatMoney(amount) {
    return Number(amount).toLocaleString("en-IN");
}

export const getPartnerLink = (source) => {
    if(source === "mint") return process.env.REACT_APP_LOC_PARTNER_LINK_MINT;
    if(source === "ht_media") return process.env.REACT_APP_LOC_PARTNER_LINK_HT_MEDIA;
    if(source === "hindustan_live") return process.env.REACT_APP_LOC_PARTNER_LINK_HINDUSTAN_LIVE;
    if(source === "shiprocket") return process.env.REACT_APP_LOC_PARTNER_LINK_SHIPROCKET;
    if(source === "indialends") return process.env.REACT_APP_LOC_PARTNER_LINK_INDIALENDS;
}

export const awsBaseUrl = process.env.REACT_APP_AWS_BASE_URL;

export const VKYC_STATUS = {
    INITIATED: "initiated",
    SCHEDULED: "scheduled",
    LIVE: "live",
    REJECTED: "rejected",
    ASSIGNED: "assigned",
    FRESH: "fresh",
}